/** color3 foi necessário por causa do cartão Multi que tem fonte branca
 *   e estava fazendo alguns itens ficarem invisíveis como as opções do cartão
 *   Arquivo CardActions.jsx
 * */

import { RefeicaoCaixa, AlimentacaoCaixa } from '~/assets/jvcef/cards';

export default function dashboardColors(theme, type) {
  const { colors } = theme;
  switch (type) {
    case 27:
      return {
        color1: colors.white,
        color2: '#fe0080',
        color3: '#fe0080',
        bgImage: '',
        bgModal: '#fe0080',
        colorModal: colors.white,
      };
    case 201:
      return {
        color1: colors.white,
        color2: '#fe0080',
        color3: '#fe0080',
        bgImage: '',
        bgModal: '#fe0080',
        colorModal: colors.white,
      };
    case 202:
      return {
        color1: colors.white,
        color2: '#c99b40',
        color3: '#c99b40',
        bgImage: '',
        bgModal: '#c99b40',
        colorModal: colors.white,
      };
    case 203:
      return {
        color1: colors.white,
        color2: colors.compras,
        color3: colors.compras,
        bgImage: '',
        bgModal: colors.compras,
        colorModal: colors.white,
      };
    case 31:
      return {
        color1: colors.white,
        color2: '#f89520',
        color3: '#f89520',
        bgImage: '',
        bgModal: '#f89520',
        colorModal: colors.white,
      };
    case 28:
      return {
        color1: colors.white,
        color2: '#78868d',
        color3: '#78868d',
        bgImage: '',
        bgModal: '#78868d',
        colorModal: colors.white,
      };
    case 30:
      return {
        color1: colors.white,
        color2: '#007dce',
        color3: '#007dce',
        bgImage: '',
        bgModal: '#007dce',
        colorModal: colors.white,
      };
    case 204:
      return {
        color1: colors.white,
        color2: '#fe0080',
        color3: '#fe0080',
        bgImage: '',
        bgModal: '#fe0080',
        colorModal: colors.white,
      };
    case 243:
      return {
        color1: colors.white,
        color2: '#f89520',
        color3: '#f89520',
        bgImage: '',
        bgModal: '#f89520',
        colorModal: colors.white,
      };
    case 207:
      return {
        color1: colors.gray400,
        color2: colors.white,
        color3: colors.gray400,
        bgImage: '',
        bgModal: colors.gray400,
        colorModal: colors.white,
      };
    case 209:
      return {
        color1: colors.white,
        color2: '#33c5c5',
        color3: '#33c5c5',
        bgImage: '',
        bgModal: '#33c5c5',
        colorModal: colors.white,
      };

    case 211:
    case 212:
    case 213:
    case 244:
    case 245:
    case 262:
    case 272:
    case 293:
      return {
        color1: colors.white,
        color2: '#00ff00',
        color3: '#00ff00',
        bgImage: '',
        bgModal: '#00ff00',
        colorModal: colors.white,
      };

    case 681:
      return {
        color1: colors.white,
        color2: '#f8001c',
        color3: '#f8001c',
        bgImage: '',
        bgModal: '#f8001c',
        colorModal: colors.white,
      };
    case 'caixa':
      return {
        color1: colors.white,
        color2: colors.secondary,
        color3: colors.secondary,
        bgImage: '',
        bgModal: colors.cultura,
        colorModal: colors.white,
      };
    case 270:
    case 271:
      return {
        color1: colors.white,
        color2: colors.secondary,
        color3: colors.secondary,
        bgImage: RefeicaoCaixa,
        bgModal: colors.white,
        colorModal: colors.black,
      };
    case 290:
    case 291:
      return {
        color1: colors.white,
        color2: colors.secondary,
        color3: colors.secondary,
        bgImage: AlimentacaoCaixa,
        bgModal: colors.white,
        colorModal: colors.black,
      };
    default:
      return {
        color1: colors.white,
        color2: colors.gray400,
        color3: colors.gray400,
        bgImage: '',
        bgModal: colors.gray400,
        colorModal: colors.white,
      };
  }
}
